<div class="container" (click)="onClick($event)">
    <smart-icon name="download" class="light"></smart-icon>
</div>